import React, { useEffect, useRef, useState } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import { useNavigate } from "react-router-dom";

DataTable.use(DT);

export const ContentStatusTable = ({ contentStatuses = [] }) => {
  const tableRef = useRef(null);
  const [localContentStatuses, setLocalContentStatuses] = useState(contentStatuses);
  const navigate = useNavigate();

  useEffect(() => {
    setLocalContentStatuses(contentStatuses);
  }, [contentStatuses]);

  window.editContent = (contentId, sectionId, contentType) => {
    console.log("!!! EDIT CLICKED: ", sectionId, contentType);
    // find the section in the course 
    const subsection = contentType === "quiz-question" ? "quiz" : "content";
    navigate(`/levelsection/${sectionId}#${subsection}&${contentId}`);
  }


  const tableData = localContentStatuses.map((status) => {
    console.log("!!! STATUS: ", status);
    return [
      status.public_id,
      status.level_title,
      status.section_title,
      status.content_type,
      status.comments,
      status.deleted ? "deleted" : status.status,
      `${status.user_firstname} ${status.user_lastname}`,
      status.deleted ? "" : `<div style="display: flex; flex-direction: row;"><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 20px; color: black;" onClick="window.editContent('${status.content_public_id}', '${status.section_public_id}', '${status.content_type}')" class="bg-emerald-400 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">✎</button></div></div>`,
    ]
  });
  return (
    <div style={{ width: "100%", position: "relative", paddingLeft: "20px", paddingRight: "20px" }}>
      <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", justifyContent: "space-between", marginBottom: "20px" }}>
        <div style={{ fontSize: "16px", fontStyle: "italic", fontWeight: "normal" }}>
          {localContentStatuses.length.toLocaleString()} statuses
        </div>
      </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        style={{ width: "100%" }}
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
          order: [[6, "desc"]],
        }}
      >
        <thead>
          <tr>
            <th>Id</th>
            <th>Level</th>
            <th>Section</th>
            <th>Content Type</th>
            <th>Comments</th>
            <th>Status</th>
            <th>User</th>
            <th>Actions</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  );
};

export default ContentStatusTable;
